import { format, parseISO } from 'date-fns';
import locale from 'date-fns/locale/pt-BR';
import { useMemo } from 'react';
import { IUnidadeFaturaPrePago } from './useQueryFilterHistorico/index.d';
export const useTransformFatura = (props, { administrador }) => {
    const unidadeFaturaPrePago: IUnidadeFaturaPrePago[] = props.response || [];

    const data = useMemo(() => {
        return unidadeFaturaPrePago.map((fatura) => {
            const dataTransacao = format(
                parseISO(fatura?.criadoEm || new Date().toISOString()),
                `dd 'de' MMMM 'de' yyyy`,
                { locale }
            );
            
            const valorFormatado = new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            }).format(fatura?.valor || 0);
            return {
                lineClassName: '',
                colunas: [
                    {
                        tipo: 'Texto',
                        width: '1fr',
                        marginRight: '0',
                        titulo: fatura?.nomeFantasia,
                        subtitulo: fatura?.identificador,
                    },
                    {
                        tipo: 'Texto',
                        width: '20rem',
                        marginRight: '0',
                        titulo: dataTransacao,
                    },
                    {
                        tipo: 'Texto',
                        width: '15rem',
                        marginRight: '0',
                        titulo: valorFormatado,
                        subtitulo: fatura?.coletaId 
                            ? `Pagamento de coleta ${fatura?.numeroInterno || ''}` 
                            : 'Crédito adicionado',
                    },
                    {
                        tipo: 'Texto',
                        titulo: '',
                        subtitulo: '',
                        width: '13rem',
                        marginRight: '0',
                        temaBotao: '1',                    },
                ],
            };
        });
    }, [unidadeFaturaPrePago, administrador]);

    return data;
};
